import { WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import {
  VisitorMeasureDrawerControlWrapper as BaseVisitorMeasureDrawerControlButton,
  VisitorMeasureDrawerControlMenuItemWrapper as BaseVisitorMeasureDrawerControlMenuItem,
} from '../../measures/VisitorMeasureDrawerControlWrapper';

export function VisitorWaitingMeasureDrawerControlButton({ className }: { className?: string }) {
  return (
    <BaseVisitorMeasureDrawerControlButton className={className} drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />
  );
}

export function VisitorWaitingMeasureDrawerControlMenuItem({ className }: { className?: string }) {
  return (
    <BaseVisitorMeasureDrawerControlMenuItem
      className={className}
      drawerId={WAITING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}
